import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import "./JPLMemberInformationForm.scss";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function JPLMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);

  const [last8Vin] = useState(props.currState.MemberLookup.last8Vin);
  const [serviceCardNum] = useState(props.currState.MemberLookup.serviceCardNum);
  const [licensePlate] = useState(props.currState.MemberLookup.licensePlate);
  const [vin] = useState(props.currState.MemberLookup.vin);
  const [make] = useState(props.currState.MemberLookup.make);
  const [model] = useState(props.currState.MemberLookup.model);
  const [year] = useState(props.currState.MemberLookup.year);
  const [vehicleWeight] = useState(props.currState.MemberLookup.vehicleWeight);
  const [color] = useState(props.currState.MemberLookup.color);
  const [firstName, setFirstName] = useState(props.context.state.FirstName);
  const [lastName, setLastName] = useState(props.context.state.LastName);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [accountInfo, setAccountInfo] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [createContacts, setCreateContact] = useState(["Create a new contact", ""]);

  const [checkDuplicateName, setCheckDuplicateName] = useState(false);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    onSubmit();
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  }, []);

  useEffect(() => {
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  }, [contacts]);

  // useEffect(() => {
  //   //devLog(props);
  //   onSubmit();
  // }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onMemberInfo = (memberInfo, contactInfo) => {
    if (typeof props.onMemberInfo === "function") {
      props.onMemberInfo(memberInfo, contactInfo);
      //devLog("memberInfo: " + memberInfo);
    }
  };

  //select Contact function, set selectContact to contactInfo => input
  //
  const onSelect = (sc) => {
    //devLog("selected Contact: ", sc);
    setSelectedContact(sc);
    onMemberInfo(accountInfo, sc);
    if (sc === undefined) {
      //devLog("selected undefined Contact: ", props.context.state.FirstName + " " + props.context.state.LastName);
      setFirstName(props.context.state.FirstName);
      setLastName(props.context.state.LastName);
    } else {
      setFirstName(sc.firstName);
      setLastName(sc.lastName);
      //devLog("selected defined Contact: ", sc.firstName + " " + sc.lastName);
    }
  };

  // const onSelectNewContact = (contactInfo) => {
  //   //devLog("selected Contact: ", contactInfo);
  //   setSelectedContact(
  //     props.currState.FirstName + " " + props.currState.LastName
  //   );
  //   //devLog("New Contact Name: ", selectedContact);
  //   onMemberInfo(memberInfo, contactInfo);
  // };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    //devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue), selectedContact);
      setAccountInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        last8Vin: last8Vin,
        serviceCardNum: serviceCardNum,
        searchType: searchType,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        //devLog("JSON", json);
        if (typeof json.data.accountInfo === "object" && typeof json.data.contactInfo === "object") {
          if (!json.data.error) {
            setContacts(json.data.contactInfo);
            onMemberInfo(json.data.accountInfo, selectedContact);
            setAccountInfo(json.data.accountInfo);
            onLoad(true);
          } else {
            setContacts([]);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts([]);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts([]);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        //devLog("error", e);
        setLoading(false);
        setContacts([]);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const checkDuplicateContact = (firstName, lastName) => {
    if (firstName !== "" && lastName !== "") {
      contacts.map((con, index) => {
        if (
          con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
          con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim()
        ) {
          setCheckDuplicateName(true);
        }
        return checkDuplicateContact;
      });
    }
  };

  return (
    <>
      {loading ? (
        <>
          <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} />
        </>
      ) : (
        <>
          <div className="formContainer">
            {accountInfo ? (
              <div className="policyData">
                <div className="policyHeader">
                  <h4>{t("description.ContractInformationHeader4")}</h4>
                  <hr />
                  <div className="policy-info-line">
                    <b>{t("ATF.PolicyInformation.ConfirmCustomerYear")}:</b> {accountInfo.year}
                  </div>
                  <hr />
                  <div className="policy-info-line">
                    <b>{t("ATF.PolicyInformation.ConfirmCustomerMake")}:</b> {accountInfo.make}
                  </div>
                  <hr />
                  <div className="policy-info-line">
                    <b>{t("ATF.PolicyInformation.ConfirmCustomerModel")}:</b> {accountInfo.model}
                  </div>
                  <hr />
                  <div className="policy-info-line">
                    <b>{t("ATF.PolicyInformation.ConfirmCustomerColor")}:</b> {accountInfo.color}
                  </div>
                  <hr />
                  <div className="policy-info-line">
                    <b>{t("ATF.PolicyInformation.ConfirmCustomerLast8Vin")}:</b> {accountInfo.last8Vin}
                  </div>
                  <hr />
                </div>
              </div>
            ) : (
              <></>
            )}
            {contacts && !error ? (
              <div className="policyData">
                <div className="policyHeader driverContainer">
                  {contacts.length > 0 && (
                    <>
                      <h4 className="driver-header">{t("description.ContactInformationHeader")}</h4>
                      <hr />
                      {contacts.map((contact, index) => {
                        return (
                          <div
                            key={index}
                            value={contact}
                            className={`vehicle-list-item ${selectedContact === contact ? "selected" : ""}`}
                            onClick={(e) => {
                              onSelect(contact);
                            }}
                          >
                            <div className="contact-list driver-list">
                              <input
                                className="vehicleSelector"
                                type="radio"
                                name="policy-vehicle"
                                checked={selectedContact === contact ? "selected" : ""}
                              />
                              <div value={contact} className="vehicle-list-item-col-1">
                                <h5 value={contact} className="name-h5">
                                  {contact.firstName} {contact.lastName}
                                </h5>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}

                  {!checkDuplicateName ? (
                    <>
                      <hr />
                      <h4 className="driver-header">{t("description.AddContactInformationHeader")}</h4>
                      <hr />
                      <div className="contact-list driver-list">
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="policy-vehicle"
                          checked={selectedContact === undefined}
                          onClick={(e) => {
                            // setSelectedContact(undefined);
                            onSelect(undefined);
                          }}
                        />
                        <div className="vehicle-list-item-col-1">
                          <h5 className="name-h5">
                            {props.currState.FirstName} {props.currState.LastName}
                          </h5>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          {error ? (
            <div className="errorSection">
              <b className="error">{error}</b>
              <div>
                <button className="ui-btn" onClick={onUserBack}>
                  {t("description.TryAgain")}
                </button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}

      {/* {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>} */}
    </>
  );
}

export default JPLMemberInformationForm;
